import Vue from 'vue'
import Vuex from 'vuex'
// import { getDatabase, ref, onValue} from "firebase/database";
import firebase from "./firebase";
// const database = getDatabase(firebase);
const DB = firebase.database();
const db = '01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY'

// dbRef.child("ondemand").get().then((snapshot) => {
//   if (snapshot.exists()) {
//     console.log(snapshot.val());
//   } else {
//     console.log("No data available");
//   }
// }).catch((error) => {
//   console.error(error);
// });
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        Sidebar_drawer: null,
        Customizer_drawer: false,
        SidebarColor: 'white', //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
        SidebarBg: '',
        total_attendance:0,
        programs:[],
        programsSort:[],
        submissions:[],
        onDemandRecords:[],
        onDemandStatus:false,
        lgasAll:[]
    },
    mutations: {
        SET_SIDEBAR_DRAWER(state, payload) {
            state.Sidebar_drawer = payload
        },
        SET_CUSTOMIZER_DRAWER(state, payload) {
            state.Customizer_drawer = payload
        },
        SET_SIDEBAR_COLOR(state, payload) {
            state.SidebarColor = payload
        },
        SET_TOTAL_ATTENDANCE(state, payload) {
            state.total_attendance = payload
        },
    },
    actions: {
        async getOnDemandStatus(context){
            let res= null
            let data = DB.ref(db+"/settings/main-settings");
            data.on("value",(dta) => {
                res = dta.val()
                console.log("result of getOnDemandStatus", res) 
                context.state.onDemandStatus = res.onDemand
            } );
            return res;
        },
        getOnDemandRecords(context){
            // console.log()
            let data = DB.ref(db+"/ondemand");
            data.on("value",(dta) => {
                context.state.onDemandRecords = dta.val() 
            } );
        },
        updatesLGAs(context, data) {
            context.state.lgasAll = []
            for(const prop in data) context.state.lgasAll.push(prop)
        },
        updateSubm(context, data) {
            context.state.submissions = [];
            for(const prop in data) 
            {
                if(prop !== 11535){
                data[prop].ID = prop;
                context.state.submissions.push(data[prop])
                }
                
            }
        },
        updatePrograms(context, data) {
            context.state.programs = [];
            context.state.programsSort = [];
            for(const prop in data)
            {
                context.state.programsSort.push(data[prop]['Program Name'])
                context.state.programs.push({
                id: prop,
                "Program Name": data[prop]['Program Name'],
                "LGA": data[prop]['LGA'],
                "Description": data[prop]['Description'],
              })
            }
        
        },
        formatData(context, data) {
            console.log('formatData', context, data);
        },
        dataFailed(context, data) {
            console.log('dataFailed', context, data);
        },
        getPrograms() {
            // let data = DB.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Programs");
            // data.on("value",context.dispatch('formatData'),context.dispatch('dataFailed') );
        },
        update_att({commit}){
            commit('SET_TOTAL_ATTENDANCE',1000)
        },
    },
    getters: {
    }
})